import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import React, { useEffect, useState } from "react";
import { useDatabase } from "../../contexts/DatabaseContext";
import { useLocation } from "react-router";
import {
  Checkbox,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Select,
} from "@mui/material";
import { Redirect } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Register() {
  const { currentUser } = useAuth();
  const { accomplishAchievement } = useDatabase();
  const [uid, setUid] = useState(currentUser.uid);
  let q = useQuery();
  const [redirectToDashboard, setRedirectToDashboard] = useState(false);
  const [region, setRegion] = useState("");
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setRegion(event.target.value);
  };

  const handleCheck = () => {
    if (checked) {
      setChecked(false);
    } else {
      setChecked(true);
    }
  };

  useEffect(() => {
    if (q.get("id") !== null && q.get("id") === currentUser.uid) {
      setUid(q.get("id"));
    } else {
      setUid("");
      setRedirectToDashboard(true);
    }
  }, [uid, q]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData(e.currentTarget);
    if (
      data.get("firstname") === "" ||
      data.get("lastname") === "" ||
      data.get("email") === "" ||
      region === "" ||
      data.get("age") === ""
    ) {
      alert("Введите все данные");
    } else {
      db.doc(`users/${currentUser.uid}`)
        .set({
          firstname: data.get("firstName"),
          lastname: data.get("lastName"),
          middlename: data.get("thirdName"),
          email: data.get("email"),
          age: data.get("age"),
          phoneNumber: currentUser.phoneNumber,
          points: 0,
          isAdmin: false,
          invited: 0,
          region: region,
        })
        .then(() => {
          accomplishAchievement(currentUser.uid, "qgBTdSqHwHLDfwOb3e55").then(
            () => {
              setRedirectToDashboard(true);
            }
          );
        });
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar
          src="https://firebasestorage.googleapis.com/v0/b/gto-container.appspot.com/o/mossport.png?alt=media&token=422f53a0-6391-4882-9751-c186f923017c"
          sx={{ m: 1, bgcolor: "red", height: 70, width: 70 }}
        />
        <Typography component="h1" variant="h5">
          Регистрация
        </Typography>
        <Box onSubmit={handleSubmit} component="form" sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                required
                fullWidth
                id="firstName"
                label="Имя"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="lastName"
                label="Фамилия"
                name="lastName"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="thirdName"
                label="Отчество"
                id="thirdName"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel required id="demo-simple-select-label">Округ</InputLabel>
                <Select value={region} label="Регион" onChange={handleChange}>
                  <MenuItem value="Центральный">Центральный</MenuItem>
                  <MenuItem value="Северный">Северный</MenuItem>
                  <MenuItem value="Северо-Восточный">Северо-Восточный</MenuItem>
                  <MenuItem value="Восточный">Восточный</MenuItem>
                  <MenuItem value="Юго-Восточный">Юго-Восточный</MenuItem>
                  <MenuItem value="Южный">Южный</MenuItem>
                  <MenuItem value="Юго-Западный">Юго-Западный</MenuItem>
                  <MenuItem value="Западный">Западный</MenuItem>
                  <MenuItem value="Северо-Западный">Северо-Западный</MenuItem>
                  <MenuItem value="Зеленоградский">Зеленоградский</MenuItem>
                  <MenuItem value="Троицкий и Новомосковский">
                    Троицкий и Новомосковский
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={9}>
              <TextField
                required
                fullWidth
                id="email"
                type="email"
                label="Почта"
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                InputLabelProps={{ shrink: true }}
                type="number"
                required
                fullWidth
                id="age"
                label="Возраст"
                name="age"
                autoComplete="age"
              />
            </Grid>
          </Grid>

          <Checkbox onClick={handleCheck} />
          <FormControl sx={{ mt: 1 }}>
            <Typography>Я согласен с</Typography>

            <Link onClick={() => window.open("/agreement", "_blank")}>
              <Typography>политикой конфиденциальности</Typography>
            </Link>
          </FormControl>

          <Button
            disabled={!checked}
            type="submit"
            fullWidth
            color="error"
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Зарегистрироваться
          </Button>
        </Box>
      </Box>
      {redirectToDashboard ? <Redirect to="/" /> : null}
    </Container>
  );
}

export default Register;
